import { Observable } from 'rxjs';

import { ModuleTask } from 'module/page/task/module-task';

export abstract class ModuleTaskRepositoryPort {
	public abstract observeModuleTasksByIds(
		tasksId: string[]
	): Observable<ModuleTask[]>;

	public abstract saveModuleTasks(moduleTasks: ModuleTask[]): Promise<void>;
}
